import palette from "../../../styles/palette.js";

export const DropdownIcon = ({ open }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="8"
		height="6"
		viewBox="0 0 8 6"
		fill="none"
		aria-hidden="true"
	>
		<path
			d="M0.330314 1.90516L3.21591 4.79076C3.65042 5.22527 4.35232 5.22527 4.78684 4.79076L7.67243 1.90516C8.37434 1.20326 7.87298 0 6.8814 0H1.11021C0.118629 0 -0.371588 1.20326 0.330314 1.90516Z"
			fill={open ? palette.green1 : "white"}
		/>
	</svg>
);

export default DropdownIcon;
